var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.001,
    height: 15.001
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 23",
    d: "M0 7.5A7.5 7.5 0 017.5 0 7.5 7.5 0 0115 7.5 7.5 7.5 0 017.5 15 7.5 7.5 0 010 7.5zm1 0A6.508 6.508 0 007.5 14 6.509 6.509 0 0014 7.5 6.509 6.509 0 007.5 1 6.507 6.507 0 001 7.5zM7 11V6h1v5zm0-6V4h1v1z",
    fill: "#797775"
  })));
}
export default SvgNotificationInfo;